import * as React from 'react';
import loadable from '@loadable/component';
import withMicroFrontendProps, { SEOHead } from 'AppShell/Microfrontend';
import { CheckoutProps, SignupAndLoginProps } from 'AppShell/appshell_types';
import { ErrorBoundary } from 'Client/components/Generic/ErrorBoundaries';
import useRemoteLogger from 'AppShell/Microfrontend/useRemoteLogger';
import useCookieConsent from 'Client/hooks/cookieConsent/useCookieConsent';

const Checkout = loadable(() => import('mf-checkout/Main'), {
    ssr: false,
    resolveComponent: components => components.default.CheckoutPage,
}) as CheckoutProps['Main'];

const CheckoutWithBellaProps = withMicroFrontendProps(Checkout, 'mf-checkout');

const LoginAndRegister = loadable(() => import('mf-signup-and-login/Main'), {
    ssr: false,
    resolveComponent: components => components.default.LoginAndRegister,
}) as SignupAndLoginProps['LoginAndRegister'];

const SignupAndLoginProvider = loadable(() => import('mf-signup-and-login/Main'), {
    ssr: false,
    resolveComponent: components => components.default.SignupAndLoginProvider,
}) as SignupAndLoginProps['SignupAndLoginProvider'];
const SignupAndLoginProviderWithProps = withMicroFrontendProps(SignupAndLoginProvider, 'mf-checkout-signup-and-login');

const remoteName = 'mf-checkout-with-login';
const CheckoutMicroFrontend = () => {
    const remoteLogger = useRemoteLogger(remoteName);
    const cookieConsent = useCookieConsent();

    return (
        <div>
            <SEOHead noIndex />
            <ErrorBoundary boundaryName={remoteName} fallbackComponent={null} logger={remoteLogger}>
                <SignupAndLoginProviderWithProps>
                    <CheckoutWithBellaProps LoginAndRegister={LoginAndRegister} cookieConsent={cookieConsent} />
                </SignupAndLoginProviderWithProps>
            </ErrorBoundary>
        </div>
    );
};

export default CheckoutMicroFrontend;
